import React, {useEffect} from 'react';
import {Navigate, Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import Home from './pages/Home';
import DeliveredDetailPage from './pages/delivery/detail/DeliveredDetailPage';
import {AuthGuard} from './components/AuthGuard';
import LoginPage from './pages/delivery/driver/login/LoginPage';
import BlacklistSmsVerificationPage from './pages/delivery/driver/login/BlacklistSmsVerificationPage';
import ChangePasswordPage from './pages/delivery/driver/changePassword/ChangePasswordPage';
import TaskPage from 'pages/delivery/TaskPage';
import DeliveringPage from 'pages/delivery/delivering/DeliveringPage';
import DeliveringTemporaryPage from 'pages/delivery/temporary/DeliveringTemporaryPage';
import NewAssignmentsScanPage from 'pages/delivery/task/NewAssignmentsScanPage';
import TransferInScanPage from 'pages/delivery/task/TransferInScanPage';
import NewAssignmentsConfirmPage from 'pages/delivery/task/NewAssignmentsConfirmPage';
import AreaScanDetailPage from 'pages/delivery/task/AreaScanDetailPage';
import OrderDetailPage from 'pages/delivery/delivering/OrderDetailPage';
import ChatPage from 'pages/delivery/delivering/chat/ChatPage';
import ChatListPage from 'pages/delivery/delivering/chat/ChatListPage';
import AccessCodeFormPage from 'pages/delivery/delivering/AccessCodeFormPage';
import AccessInfoDetailPage from 'pages/delivery/delivering/AccessInfoDetailPage';
import PdaLoginPage from 'pages/pda/PdaLoginPage';
import PdaHomePage from 'pages/pda/PdaHomePage';
import PdaPickupArrival from 'pages/pda/PickupArrivalPage';
import PdaPickupArrivalOld from 'pages/pda/PickupArrivalOldPage';
import PdaTransferArrival from 'pages/pda/TransferArrivalPage';
import PdaBagging from 'pages/pda/BaggingPage';
import BaggingScanPageWrapper from 'pages/pda/bagging-scan/BaggingScanPageWrapper';
import OldBaggingScanPageWrapper from 'pages/pda/bagging-scan/OldBaggingScanPageWrapper';
import PdaUnbagging from 'pages/pda/UnbaggingPage';
import CartonScanPage from 'pages/pda/CartonScanPage';
import BagMergeScanPage from 'pages/pda/BagMergeScan';
import OldBagMergeScanPage from 'pages/pda/BagMergeScan/OldBagMergeScan';
import BagReshipScanPage from 'pages/pda/BagReshipScan';
import PdaDeparture from 'pages/pda/DeparturePage';
import SortingScanPage from 'pages/pda/SortingScanPage';
import OldSortingScanPage from 'pages/pda/OldSortingScanPage';
import PutawayScanPage from 'pages/pda/PutawayScanPage';
import PickingScanPage from 'pages/pda/PickingScanPage';
import PdaLoading from 'pages/pda/LoadingPage';
import PdaSealed from 'pages/pda/SealedPage';
import PdaUnsealing from 'pages/pda/UnsealingPage';
import PdaWhsArrival from 'pages/pda/WhsArrivalPage';
import PdaLanguagePage from 'pages/pda/PdaLanguagePage';
import PdaScanSettingPage from 'pages/pda/PdaScanSettingPage';
import DestroyPage from 'pages/pda/DestroyPage';
import FailedUploadsPage from "./pages/delivery/failed/FailedUploadsPage";
import DeliveredPage from "./pages/delivery/delivered/DeliveredPage";
import DeliveredTemporaryPage from "./pages/delivery/temporary/DeliveredTemporaryPage";
import TransferOutPage from "./pages/delivery/task/TransferOutPage";
import ReceivingSortingScanPage from "./pages/dsp/home/receiving-sorting/ReceivingSortingScanPage";
import DspDeliveryTaskDetailsPage from "./pages/dsp/delivery-task/DspDeliveryTaskDetailsPage";
import DspDeliveryTaskMapPage from "./pages/dsp/delivery-task/DspDeliveryTaskMapPage";
import {
  DeliveringPath,
  DeliveryDetailPath,
  DspPath,
  IncompletePromptPath,
  TaskPath,
  UserMenuPath
} from "./enums/DeliveryNavigatePathEnum";
import ReceivingSortingDetailsPage from 'pages/dsp/home/receiving-sorting/ReceivingSortingDetailsPage';
import RegisterPage from 'pages/delivery/driver/register/UnifiedRegisterPage';
import UnifiedRegisterNativePage from 'pages/delivery/driver/register/UnifiedRegisterNativePage';
import TermsOfUsePage from 'pages/delivery/driver/termsOfUse/TermsOfUsePage';
import TermsOfUseNativePage from 'pages/delivery/driver/termsOfUse/TermsOfUseNativePage';
import PrivacyPolicyPage from 'pages/delivery/driver/privacyPolicy/PrivacyPolicyPage';
import PrivacyPolicyNativePage from 'pages/delivery/driver/privacyPolicy/PrivacyPolicyNativePage';
import ChangePasswordNativePage from 'pages/delivery/driver/changePassword/ChangePasswordNativePage';
import BlacklistSmsVerificationNativePage from 'pages/delivery/driver/login/BlacklistSmsVerificationNativePage';
import { DriverAuthPath } from './enums/DriverAuthPathEnum';
import ReceivingSortingConfirmPage from "./pages/dsp/home/receiving-sorting/ReceivingSortingConfirmPage";
import MarkExceptionPage from "./pages/delivery/exception/MarkExceptionPage";
import ReturnToWarehousePage from "./pages/delivery/task/ReturnToWarehousePage";
import ReturnPage from 'pages/pda/ReturnPage';
import ReturnToWhsPage from 'pages/pda/ReturnToWhsPage';
import ReturnToWhsNewPage from 'pages/pda/ReturnToWhsNewPage';
import ReturnToWhsOldPage from 'pages/pda/ReturnToWhsOldPage';
import ReturnArrivalPage from 'pages/pda/ReturnArrivalPage';
import HoldingPage from 'pages/pda/HoldingPage';
import HandoverScanPage from 'pages/pda/HandoverScanPage';
import HubExceptionPage from 'pages/pda/HubExceptionPage';
import WarehouseExceptionPage from 'pages/pda/WarehouseExceptionPage';
import SettingsPage from "./pages/delivery/setting/SettingsPage";
import LanguagePage from "./pages/delivery/setting/language/LanguagePage";
import ScanPackageVerification from "./pages/delivery/delivering/ScanPackageVerification";
import MapModePage from "./pages/delivery/delivering/MapModePage";
import PickUpLanguagePage from "./pages/pickup/setting/language/PickUpLanguagePage";
import PickUpSettingsPage from "./pages/pickup/setting/PickUpSettingsPage";
import PickupNavigationAppPage from "./pages/pickup/setting/navigationApp/PickupNavigationAppPage";
import PickedUpPage from "./pages/pickup/pickedUp/PickedUpPage";
import PackageHandoverPage from "./pages/pickup/packageHandover/PackageHandoverPage";
import PickedUpFailedPage from "./pages/pickup/uploadFailed/PickedUpFailedPage";
import {PickingUpPath, PickupFinishedPath, PickupSettingsPath} from "./enums/PickUpNavigatePathEnum";
import PickupFailedPage from "./pages/pickup/failed/PickupFailedPage";
import PickupFinishedPage from "./pages/pickup/finished/PickupFinishedPage";
import PickupFinishedDetailPage from "./pages/pickup/finished/detail/PickupFinishedDetailPage";
import PickingUpDetailPage from 'pages/pickup/pickingUp/PickingUpDetailPage'
import PickingUpPage from "./pages/pickup/pickingUp/PickingUpPage";
import PickedUpFailedToSecPage from "./pages/pickup/pickedUp/PickedUpFailedToSecPage";
import { getUserInfo, isLoggedIn, removeUserInfo, saveUserInfo } from "./utils/auth";
import NavigationAppPage from "./pages/delivery/setting/navigationApp/NavigationAppPage";
import ParcelIdentificationPage from "./pages/delivery/identification/ParcelIdentificationPage";
import ConfigProvider from './components/ConfigProvider';
import PickingUpMapModePage from 'pages/pickup/pickingUp/PickingUpMapModePage';
import PdaGlobalSearchPage from 'pages/pda/PdaGlobalSearchPage';
import {TmsPath} from "./enums/TmsNavigatePathEnum";
import TransportPage from "./pages/tms/transporting/TransportPage";
import TransportDetailPage from "./pages/tms/transporting/TransportDetailPage";
import WeightParcelPage from 'pages/pda/WeightParcelPage';
import ArrivalPage from 'pages/pda/ArrivalScanPage';
import OldArrivalPage from 'pages/pda/OldArrivalScanPage';
import DspDeliveryTaskPage from "./pages/dsp/delivery-task/DspDeliveryTaskPage";
import DspOperationalDataPage from "./pages/dsp/operational-data/DspOperationalDataPage";
import DspOperationalDataParticularsPage from "./pages/dsp/operational-data/DspOperationalDataParticularsPage";
import DspPackageScanPage from "./pages/dsp/general-scaning/DspPackageScanPage";
import DspTrackDetailPage from "./pages/dsp/home/track-package/DspTrackDetailPage";
import DspHomePage from "./pages/dsp/DspHomePage";
import DspDeliveredPodPage from "./pages/dsp/home/delivered/DspDeliveredPodPage";
import DspMarkExceptionPage from "./pages/dsp/home/delivery-fail/DspMarkExceptionPage";
import DspParticularsDetailPage from "./pages/dsp/operational-data/DspParticularsDetailPage";
import DspParticularsPodPage from "./pages/dsp/operational-data/DspParticularsPodPage";
import DspParticularsMarkFailPage from "./pages/dsp/operational-data/DspParticularsMarkFailPage";
import DriverViolationReviewPage from "./pages/dsp/home/pod/DriverViolationReviewPage";
import IssueParcelWorkbenchPage from "./pages/dsp/home/issueParcelWorkbench/IssueParcelWorkbenchPage";
import CustomerComplaintListPage from "./pages/dsp/home/issueParcelWorkbench/CustomerComplaintListPage";
import CustomerComplaintDetailPage from "./pages/dsp/home/issueParcelWorkbench/CustomerComplaintDetailPage";
import CustomerComplaintHistoryPage from "./pages/dsp/home/issueParcelWorkbench/CustomerComplaintHistoryPage";
import TransportArrivingPage from "./pages/tms/transporting/TransportArrivingPage";
import TransportDepartingPage from "./pages/tms/transporting/TransportDepartingPage";
import TransportExceptionPage from "./pages/tms/exception/TransportExceptionPage";
import TransportExceptionReportedPage from "./pages/tms/exception/reported/TransportExceptionReportedPage";
import TransportFinishedPage from "./pages/tms/finished/TransportFinishedPage";
import TransportFinishedDetailPage from "./pages/tms/finished/detail/TransportFinishedDetailPage";
import TransportSettingsPage from "./pages/tms/setting/TransportSettingsPage";
import TransportLanguagePage from "./pages/tms/setting/language/TransportLanguagePage";
import { checkGrayscaleDriver } from 'utils/grayscaleDriverUtils';
import { checkAndShowVersionUpdate } from 'utils/versionUpdateUtils';
import ReceivingSortingSummaryPage from "./pages/dsp/home/receiving-sorting/ReceivingSortingSummaryPage";
import ReceivingSortingNewDetailsPage from "./pages/dsp/home/receiving-sorting/ReceivingSortingNewDetailsPage";
import TransportNavigationAppPage from "./pages/tms/setting/navigationApp/TransportNavigationAppPage";
import AddressCoordinateFeedbackPage from "./pages/delivery/address-coordinate-feedback/AddressCoordinateFeedbackPage";
import AddressCoordinateFeedbackNativePage from "./pages/delivery/address-coordinate-feedback/AddressCoordinateFeedbackNativePage";
import DeliveryRouteEndpointsSettingNativePage from "./pages/delivery/setting/routeEndpoints/DeliveryRouteEndpointsSettingNativePage";
import RouteEndpointsMapPickerNativePage from "./pages/delivery/setting/routeEndpoints/RouteEndpointsMapPickerNativePage";
import { syncUserInfoOnAppStart, getNativeUserInfo } from "./utils/nativeBridge";
import {
  isAppVersionGreaterThanOrEqual,
  kDoNotPassZipCodeListVersion,
  kIOSNativeDeliveryVersion,
  kNativeLoginVersion
} from 'utils/versionUtils';
import { isAndroid, isIOS } from 'utils/deviceUtils';
import {
  startHubPdaClientReportPollingManager,
  stopHubPdaClientReportPollingManager
} from './utils/clientReport/hubPdaClientReportPollingManager';
import ShipOutPage from 'pages/pda/ShipOutPage';
import ShipInPage from 'pages/pda/ShipInPage';
import TmsArrivalPage from 'pages/pda/tms/TmsArrivalPage';
import TmsLoadingPage from 'pages/pda/tms/TmsLoadingPage';
import TmsUnloadingPage from 'pages/pda/tms/TmsUnloadingPage';
import TmsLoadingDetailPage from 'pages/pda/tms/TmsLoadingDetailPage';
import TmsSealingPage from 'pages/pda/tms/TmsSealingPage';
import TmsUnsealingPage from 'pages/pda/tms/TmsUnsealingPage';
import TmsDeparturePage from 'pages/pda/tms/TmsDeparturePage';
import TmsUnLoadingDetailPage from 'pages/pda/tms/TmsUnLoadingDetailPage';
import TmsUnloadingInfoPage from 'pages/pda/tms/TmsUnloadingInfoPage';
import TmsUnloadingBagDetailPage from 'pages/pda/tms/TmsUnloadingBagDetailPage';
import TmsUploadBolPage from 'pages/pda/tms/TmsUploadBolPage';
import ReportIpLoginPage from 'pages/report-ip/ReportIpLoginPage';
import ReportIpPage from 'pages/report-ip/ReportIpPage';
import { PdaPath } from "./enums/PdaNavigatePathEnum";
import { ReportIpPath } from "./enums/ReportIpNavigatePathEnum";
import ScanVerificationTemporaryPage from "./pages/delivery/temporary/ScanVerificationTemporaryPage";
import BatchDeliveryTemporaryPage from "./pages/delivery/temporary/BatchDeliveryTemporaryPage";
import BatchFailedTemporaryPage from "./pages/delivery/temporary/BatchFailedTemporaryPage";
import MapModeTemporaryPage from "./pages/delivery/temporary/MapModeTemporaryPage";
import OrderDetailTemporaryPage from "./pages/delivery/temporary/OrderDetailTemporaryPage";
import DeliveryTemporaryPage from 'pages/delivery/temporary/DeliveryTemporaryPage';
import MarkExceptionTemporaryPage from "./pages/delivery/temporary/MarkExceptionTemporaryPage";
import SupportToolsPage from "./pages/support-tools/SupportToolsPage";
import SupportLoginPage from "./pages/support-tools/SupportLoginPage";
import { Toast } from 'antd-mobile';
import i18n from './i18n';
import { langParamToI18nLng, normalizeLangParam } from './utils/langUtils';

const HomeDispatcher = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 根据角色决定默认首页（每次从 localStorage 重新读取，确保数据最新）
    const getHomePage = () => {
      if (!isLoggedIn()) {
        return "/login";
      }
      const currentUserInfo = getUserInfo();
      const role = currentUserInfo?.account?.role?.name;
      if (role === "PICKUP_DRIVER") {
        return "/pickup/picking-up";
      } else if (role === "DSP_MANAGER") {
        return DspPath.DELIVERY_DSP_HOME;
      } else if (role === "TMS_DRIVER") {
        return TmsPath.TMS_TRANSPORTING;
      } else {
        return TaskPath.DELIVERY_TASK;
      }
    };

    // >= 8.8.0：从 native 端获取登录信息，写入 localStorage 后走正常路由
    if (isIOS() || isAndroid()) {
      isAppVersionGreaterThanOrEqual(kNativeLoginVersion).then(async (supportsNativeLogin) => {
        if (supportsNativeLogin) {
          const nativeUserInfo = await getNativeUserInfo();
          if (nativeUserInfo && nativeUserInfo.token && nativeUserInfo.account) {
            saveUserInfo(nativeUserInfo);
          } else {
            // native 未登录，清除可能存在的旧数据
            removeUserInfo();
          }
          navigate(getHomePage());
          return;
        }

        // < 8.8.0：走原有逻辑
        const userInfo = getUserInfo();
        if (isLoggedIn() && userInfo && userInfo.account.role.name === 'DELIVERY_DRIVER') {
          checkGrayscaleDriver(isIOS() ? 'delivery.native_app.driver_ids' : 'delivery.native_app.android.driver_ids').then(async (isGrayscale) => {
            const supportsDeliveryNative = await isAppVersionGreaterThanOrEqual(kIOSNativeDeliveryVersion);
            const androidDeliveryNative = await isAppVersionGreaterThanOrEqual(kDoNotPassZipCodeListVersion);
            if ((supportsDeliveryNative && isIOS() && isGrayscale) || (androidDeliveryNative && isAndroid() && isGrayscale)) {
              syncUserInfoOnAppStart(userInfo);
            }
            navigate(getHomePage());
            checkAndShowVersionUpdate();
          });
        } else {
          navigate(getHomePage());
        }
      });
      return;
    }

    // 非 App 环境（浏览器），直接导航
    navigate(getHomePage());
  }, []);
  return null
};

const App: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    // 只在 PDA 路由下尝试启动 HubPDA 上报轮询器，避免司机/其他端触发上报接口
    if (location.pathname.startsWith('/pda')) {
      startHubPdaClientReportPollingManager();
    } else {
      stopHubPdaClientReportPollingManager();
    }
  }, [location.pathname]);

  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    const lang = normalizeLangParam(sp.get('lang'));
    const nativeParams = (window as any).__nativeParams__ as { lang?: unknown } | undefined;
    const nativeLang = normalizeLangParam(typeof nativeParams?.lang === 'string' ? nativeParams.lang : undefined);
    const resolvedLang = lang ?? nativeLang;
    if (!resolvedLang) return;

    const lng = langParamToI18nLng(resolvedLang);
    if (i18n.language === lng) return;

    i18n.changeLanguage(lng).catch(() => undefined);
    try {
      localStorage.setItem('i18nextLng', lng);
    } catch {
      // ignore
    }
  }, [location.search]);

  return (
    <ConfigProvider>
      <div className="app-container">
        <Routes>
        {/* 支持工具路由 */}
        <Route path="/support-tools" element={<SupportToolsPage />} />
        <Route path="/support-tools/support-login" element={<SupportLoginPage />} />

        {/* 登录相关路由 */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/driver/blacklist-sms-verification" element={<BlacklistSmsVerificationPage />} />
        <Route path="/driver/register" element={<RegisterPage />} />
        <Route path="/driver/changePassword" element={<ChangePasswordPage />} />
        <Route path="/driver/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="/driver/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path={DriverAuthPath.DRIVER_REGISTER_NATIVE} element={<UnifiedRegisterNativePage />} />
        <Route path={DriverAuthPath.DRIVER_BLACKLIST_SMS_VERIFICATION_NATIVE} element={<BlacklistSmsVerificationNativePage />} />
        <Route path={DriverAuthPath.DRIVER_CHANGE_PASSWORD_NATIVE} element={<ChangePasswordNativePage />} />
        <Route path={DriverAuthPath.DRIVER_TERMS_OF_USE_NATIVE} element={<TermsOfUseNativePage />} />
        <Route path={DriverAuthPath.DRIVER_PRIVACY_POLICY_NATIVE} element={<PrivacyPolicyNativePage />} />
        <Route path="/home" element={<AuthGuard> <Home /> </AuthGuard>} />
        <Route path="/" element={<HomeDispatcher />} />

        <Route path="/pda/login" element={<PdaLoginPage />} />
        <Route path="/pda/home" element={<AuthGuard redirectTo="/pda/login"><PdaHomePage /></AuthGuard>} />
        <Route path="/pda/search" element={<AuthGuard redirectTo="/pda/login"><PdaGlobalSearchPage /></AuthGuard>} />
        <Route path="/pda/arrival" element={<AuthGuard redirectTo="/pda/login"><ArrivalPage /></AuthGuard>} />
        <Route path="/pda/arrival-old" element={<AuthGuard redirectTo="/pda/login"><OldArrivalPage /></AuthGuard>} />
        <Route path="/pda/pickup-arrival" element={<AuthGuard redirectTo="/pda/login"><PdaPickupArrival /></AuthGuard>} />
        <Route path="/pda/pickup-arrival-old" element={<AuthGuard redirectTo="/pda/login"><PdaPickupArrivalOld /></AuthGuard>} />
        <Route path="/pda/transfer-arrival" element={<AuthGuard redirectTo="/pda/login"><PdaTransferArrival /></AuthGuard>} />
        <Route path="/pda/bagging" element={<AuthGuard redirectTo="/pda/login"><BaggingScanPageWrapper /></AuthGuard>} />
        <Route path="/pda/bagging-old" element={<AuthGuard redirectTo="/pda/login"><OldBaggingScanPageWrapper /></AuthGuard>} />
        <Route path="/pda/unbagging" element={<AuthGuard redirectTo="/pda/login"><PdaUnbagging /></AuthGuard>} />
        <Route path="/pda/carton-scan" element={<AuthGuard redirectTo="/pda/login"><CartonScanPage /></AuthGuard>} />
        <Route path="/pda/bag-merge-scan" element={<AuthGuard redirectTo="/pda/login"><BagMergeScanPage /></AuthGuard>} />
        <Route path="/pda/bag-merge-scan-old" element={<AuthGuard redirectTo="/pda/login"><OldBagMergeScanPage /></AuthGuard>} />
        <Route path="/pda/bag-reship-scan" element={<AuthGuard redirectTo="/pda/login"><BagReshipScanPage /></AuthGuard>} />
        <Route path="/pda/departure" element={<AuthGuard redirectTo="/pda/login"><PdaDeparture /></AuthGuard>} />
        <Route path="/pda/sorting" element={<AuthGuard redirectTo="/pda/login"><SortingScanPage /></AuthGuard>} />
        <Route path="/pda/sorting-old" element={<AuthGuard redirectTo="/pda/login"><OldSortingScanPage /></AuthGuard>} />
        <Route path="/pda/putaway" element={<AuthGuard redirectTo="/pda/login"><PutawayScanPage /></AuthGuard>} />
        <Route path="/pda/picking" element={<AuthGuard redirectTo="/pda/login"><PickingScanPage /></AuthGuard>} />
        <Route path="/pda/loading" element={<AuthGuard redirectTo="/pda/login"><PdaLoading /></AuthGuard>} />
        <Route path="/pda/sealed" element={<AuthGuard redirectTo="/pda/login"><PdaSealed /></AuthGuard>} />
        <Route path="/pda/unsealing" element={<AuthGuard redirectTo="/pda/login"><PdaUnsealing /></AuthGuard>} />
        <Route path="/pda/whs-arrival" element={<AuthGuard redirectTo="/pda/login"><PdaWhsArrival /></AuthGuard>} />
        <Route path="/pda/return" element={<AuthGuard redirectTo="/pda/login"><ReturnPage /></AuthGuard>} />
        <Route path="/pda/return-to-whs" element={<AuthGuard redirectTo="/pda/login"><ReturnToWhsPage /></AuthGuard>} />
        <Route path="/pda/return-to-whs-new" element={<AuthGuard redirectTo="/pda/login"><ReturnToWhsNewPage /></AuthGuard>} />
        <Route path="/pda/return-to-whs-old" element={<AuthGuard redirectTo="/pda/login"><ReturnToWhsOldPage /></AuthGuard>} />
        <Route path="/pda/return-arrival" element={<AuthGuard redirectTo="/pda/login"><ReturnArrivalPage /></AuthGuard>} />
        <Route path="/pda/holding" element={<AuthGuard redirectTo="/pda/login"><HoldingPage /></AuthGuard>} />
        <Route path="/pda/handover" element={<AuthGuard redirectTo="/pda/login"><HandoverScanPage /></AuthGuard>} />
        <Route path="/pda/destroy" element={<AuthGuard redirectTo="/pda/login"><DestroyPage /></AuthGuard>} />
        <Route path="/pda/weightParcel" element={<AuthGuard redirectTo="/pda/login"><WeightParcelPage/></AuthGuard>} />
        <Route path="/pda/language" element={<AuthGuard redirectTo="/pda/login"><PdaLanguagePage /></AuthGuard>} />
        <Route path="/pda/scan-setting" element={<AuthGuard redirectTo="/pda/login"><PdaScanSettingPage /></AuthGuard>} />
        <Route path="/pda/hubException" element={<AuthGuard redirectTo="/pda/login"><HubExceptionPage /></AuthGuard>} />
        <Route path="/pda/warehouseException" element={<AuthGuard redirectTo="/pda/login"><WarehouseExceptionPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_SHIP_OUT} element={<AuthGuard redirectTo="/pda/login"><ShipOutPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_SHIP_IN} element={<AuthGuard redirectTo="/pda/login"><ShipInPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_ARRIVAL} element={<AuthGuard redirectTo="/pda/login"><TmsArrivalPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_LOADING} element={<AuthGuard redirectTo="/pda/login"><TmsLoadingPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_LOADING_DETAIL} element={<AuthGuard redirectTo="/pda/login"><TmsLoadingDetailPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_SEALING} element={<AuthGuard redirectTo="/pda/login"><TmsSealingPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_UNSEALING} element={<AuthGuard redirectTo="/pda/login"><TmsUnsealingPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_DEPARTURE} element={<AuthGuard redirectTo="/pda/login"><TmsDeparturePage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_UNLOADING} element={<AuthGuard redirectTo="/pda/login"><TmsUnloadingPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_UNLOADING_DETAIL} element={<AuthGuard redirectTo="/pda/login"><TmsUnLoadingDetailPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_UNLOADING_INFO} element={<AuthGuard redirectTo="/pda/login"><TmsUnloadingInfoPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_UNLOADING_BAG_DETAIL} element={<AuthGuard redirectTo="/pda/login"><TmsUnloadingBagDetailPage /></AuthGuard>} />
        <Route path={PdaPath.PDA_TMS_UPLOAD_BOL} element={<AuthGuard redirectTo="/pda/login"><TmsUploadBolPage /></AuthGuard>} />
        <Route path={ReportIpPath.REPORT_IP_LOGIN} element={<ReportIpLoginPage />} />
        <Route path={ReportIpPath.REPORT_IP} element={<AuthGuard redirectTo={ReportIpPath.REPORT_IP_LOGIN}><ReportIpPage /></AuthGuard>} />
          {/* 任务相关路由 */}
        <Route path={TaskPath.DELIVERY_TASK} element={<AuthGuard redirectTo="/login"><TaskPage /></AuthGuard>} />
        <Route path={TaskPath.DELIVERY_TASK_ASSIGNMENTS} element={<AuthGuard redirectTo="/login"><NewAssignmentsScanPage /></AuthGuard>} />
        <Route path={TaskPath.DELIVERY_TASK_RETURN} element={<AuthGuard redirectTo="/login"><ReturnToWarehousePage /></AuthGuard>} />
        <Route path={TaskPath.DELIVERY_TASK_TRANSFER_IN} element={<AuthGuard redirectTo="/login"><TransferInScanPage /></AuthGuard>} />
        <Route path={TaskPath.DELIVERY_TASK_TRANSFER_OUT} element={<AuthGuard redirectTo="/login"><TransferOutPage /></AuthGuard>} />
        <Route path={TaskPath.DELIVERY_TASK_AREA_SCAN_DETAIL} element={<AuthGuard redirectTo="/login"><AreaScanDetailPage /></AuthGuard>} />
        <Route path={IncompletePromptPath.DELIVERY_NEW_ASSIGNMENT_START_CONFIRM} element={<AuthGuard redirectTo="/login"><NewAssignmentsConfirmPage /></AuthGuard>} />
        {/* 配送相关路由 */}
        //todo : zhaojunze
        <Route path={DeliveringPath.DELIVERY_DELIVERING} element={<AuthGuard redirectTo="/login"><DeliveringPage /></AuthGuard>} />
        <Route path={"/delivery/delivering/temporary"} element={<AuthGuard redirectTo="/login"><DeliveringTemporaryPage /></AuthGuard>} />
        <Route path={DeliveringPath.DELIVERY_DELIVERING_ORDER} element={<AuthGuard redirectTo="/login"><OrderDetailPage /></AuthGuard>} />
        <Route path={DeliveringPath.DELIVERY_CHAT} element={<AuthGuard redirectTo="/login"><ChatPage /></AuthGuard>} />
        <Route path={DeliveringPath.DELIVERY_CHAT_LIST} element={<AuthGuard redirectTo="/login"><ChatListPage /></AuthGuard>} />
        <Route path={DeliveryDetailPath.DELIVERY_DELIVERING_ORDER_DETAIL} element={<AuthGuard redirectTo="/login"><DeliveredDetailPage /></AuthGuard>} />
        <Route path={DeliveryDetailPath.DELIVERY_DELIVERING_ORDER_DETAIL_ADD_ACCESS_CODE} element={<AuthGuard redirectTo="/login"><AccessCodeFormPage /></AuthGuard>} />
        <Route path={DeliveryDetailPath.DELIVERY_DELIVERING_ORDER_DETAIL_ACCESS_INFO} element={<AuthGuard redirectTo="/login"><AccessInfoDetailPage /></AuthGuard>} />
        <Route path={DeliveryDetailPath.DELIVERY_DELIVERING_ORDER_DETAIL_UPDATE_ACCESS_CODE} element={<AuthGuard redirectTo="/login"><AccessCodeFormPage /></AuthGuard>} />
        <Route path={DeliveringPath.DELIVERY_MARK_EXCEPTION} element={<AuthGuard redirectTo="/login"><MarkExceptionPage /></AuthGuard>} />
        <Route path={DeliveringPath.DELIVERY_SCAN_PACKAGE} element={<AuthGuard redirectTo="/login"><ScanPackageVerification /></AuthGuard>} />
        <Route path={DeliveringPath.DELIVERY_MAP_MODE} element={<AuthGuard redirectTo="/login"><MapModePage /></AuthGuard>} />
        <Route path={DeliveringPath.DELIVERY_ADDRESS_COORDINATE_FEEDBACK} element={<AuthGuard redirectTo="/login"><AddressCoordinateFeedbackPage /></AuthGuard>} />
        <Route path={DeliveringPath.DELIVERY_ADDRESS_COORDINATE_FEEDBACK_NATIVE} element={<AddressCoordinateFeedbackNativePage />} />
        {/* 派送app临时支持路由 */}
        <Route path={"/delivery/scan-verification-temporary"} element={<AuthGuard redirectTo="/login"><ScanVerificationTemporaryPage /></AuthGuard>} />
        <Route path={"/delivery/temporary/batch-delivery"} element={<AuthGuard redirectTo="/login"><BatchDeliveryTemporaryPage /></AuthGuard>} />
        <Route path={"/delivery/temporary/delivery"} element={<AuthGuard redirectTo="/login"><DeliveryTemporaryPage /></AuthGuard>} />
        <Route path={"/delivery/temporary/batch-failed"} element={<AuthGuard redirectTo="/login"><BatchFailedTemporaryPage /></AuthGuard>} />

        <Route path={"/delivery/delivering/temporary/:trackingNumber"} element={<AuthGuard redirectTo="/login"><OrderDetailTemporaryPage /></AuthGuard>} />
        <Route path={"/delivery/temporary/map-mode"} element={<AuthGuard redirectTo="/login"><MapModeTemporaryPage /></AuthGuard>} />
        <Route path={"/delivery/temporary/mark-exception"} element={<AuthGuard redirectTo="/login"><MarkExceptionTemporaryPage /></AuthGuard>} />
        {/* 左侧菜单栏相关路由 */}
        <Route path={UserMenuPath.USER_MENU_DELIVERED} element={<AuthGuard redirectTo="/login"><DeliveredPage /></AuthGuard>} />
        <Route path={"/delivery/delivered/temporary"} element={<AuthGuard redirectTo="/login"><DeliveredTemporaryPage /></AuthGuard>} />
        <Route path={UserMenuPath.USER_MENU_FAILED} element={<AuthGuard redirectTo="/login"><FailedUploadsPage /></AuthGuard>} />
        <Route path={UserMenuPath.USER_MENU_SETTINGS} element={<AuthGuard redirectTo="/login"><SettingsPage /></AuthGuard>} />
        <Route path={UserMenuPath.USER_MENU_SETTINGS_LANGUAGE} element={<AuthGuard redirectTo="/login"><LanguagePage /></AuthGuard>} />
        <Route path={UserMenuPath.USER_MENU_SETTINGS_NAVIGATION_APP} element={<AuthGuard redirectTo="/login"><NavigationAppPage /></AuthGuard>} />
        <Route path={UserMenuPath.USER_MENU_SETTINGS_ROUTE_ENDPOINTS_NATIVE} element={<DeliveryRouteEndpointsSettingNativePage />} />
        <Route path={UserMenuPath.USER_MENU_SETTINGS_ROUTE_ENDPOINTS_MAP_PICKER_NATIVE} element={<RouteEndpointsMapPickerNativePage />} />
        {/* 司机学习中心已迁移至 native 入口（NativeApp.tsx / DeliveryNativePath.LEARNING_CENTER*） */}
        {/* DSP经理相关路由 */}
        <Route path={DspPath.DELIVERY_DSP_HOME} element={<AuthGuard redirectTo="/login"><DspHomePage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_TASK} element={<AuthGuard redirectTo="/login"><DspDeliveryTaskPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_OPERATIONAL} element={<AuthGuard redirectTo="/login"><DspOperationalDataPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_OPERATIONAL_PARTICULARS} element={<AuthGuard redirectTo="/login"><DspOperationalDataParticularsPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_OPERATIONAL_PARTICULARS_DETAIL} element={<AuthGuard redirectTo="/login"><DspParticularsDetailPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_OPERATIONAL_PARTICULARS_POD} element={<AuthGuard redirectTo="/login"><DspParticularsPodPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_OPERATIONAL_PARTICULARS_MARK_FAIL} element={<AuthGuard redirectTo="/login"><DspParticularsMarkFailPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_RECEIVING_SORTING_SCAN} element={<AuthGuard redirectTo="/login"><ReceivingSortingScanPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_RECEIVING_SORTING_DETAILS} element={<AuthGuard redirectTo="/login"><ReceivingSortingDetailsPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_RECEIVING_SORTING_NEW_DETAILS} element={<AuthGuard redirectTo="/login"><ReceivingSortingNewDetailsPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_RECEIVING_SORTING_CONFIRM} element={<AuthGuard redirectTo="/login"><ReceivingSortingConfirmPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_RECEIVING_SORTING_SUMMARY} element={<AuthGuard redirectTo="/login"><ReceivingSortingSummaryPage/></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_PACKAGE_SCAN} element={<AuthGuard redirectTo="/login"><DspPackageScanPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_TRACK_DETAIL} element={<AuthGuard redirectTo="/login"><DspTrackDetailPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_DELIVERED_POD} element={<AuthGuard redirectTo="/login"><DspDeliveredPodPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_MARK_EXCEPTION} element={<AuthGuard redirectTo="/login"><DspMarkExceptionPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_DELIVERY_TASK_DETAILS} element={<AuthGuard redirectTo="/login"><DspDeliveryTaskDetailsPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_DELIVERY_TASK_MAP} element={<AuthGuard redirectTo="/login"><DspDeliveryTaskMapPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_DRIVER_VIOLATION_REVIEW} element={<AuthGuard redirectTo="/login"><DriverViolationReviewPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_ISSUE_PARCEL_WORKBENCH} element={<AuthGuard redirectTo="/login"><IssueParcelWorkbenchPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_COMPLAINT_LIST} element={<AuthGuard redirectTo="/login"><CustomerComplaintListPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_COMPLAINT_HISTORY} element={<AuthGuard redirectTo="/login"><CustomerComplaintHistoryPage /></AuthGuard>} />
        <Route path={DspPath.DELIVERY_DSP_COMPLAINT_DETAIL} element={<AuthGuard redirectTo="/login"><CustomerComplaintDetailPage /></AuthGuard>} />

        {/*揽收app相关路由*/}
        <Route path="/pickup/picking-up" element={<AuthGuard redirectTo="/login"><PickingUpPage /></AuthGuard>} />
        <Route path="/pickup/picked-up/:appointmentId/:selectedUnit" element={<AuthGuard redirectTo="/login"><PickedUpPage /></AuthGuard>} />
        <Route path={PickupSettingsPath.PICKUP_SETTINGS} element={<AuthGuard redirectTo="/login"><PickUpSettingsPage /></AuthGuard>} />
        <Route path={PickupSettingsPath.PICKUP_SETTINGS_LANGUAGE} element={<AuthGuard redirectTo="/login"><PickUpLanguagePage /></AuthGuard>} />
        <Route path={PickupSettingsPath.PICKUP_SETTINGS_NAVIGATION_APP} element={<AuthGuard redirectTo="/login"><PickupNavigationAppPage /></AuthGuard>} />
        <Route path="/pickup/package-handover" element={<AuthGuard redirectTo="/login"><PackageHandoverPage /></AuthGuard>} />
        <Route path="/pickup/upload-failed" element={<AuthGuard redirectTo="/login"><PickedUpFailedPage /></AuthGuard>} />
        {/*揽收相关路由 */}
        <Route path={PickingUpPath.PICKUP_PICKINGUP_DETAIL} element={<AuthGuard redirectTo="/login"><PickingUpDetailPage /></AuthGuard>} />
        <Route path={PickingUpPath.PICKUP_FAILED} element={<AuthGuard redirectTo="/login"><PickupFailedPage /></AuthGuard>} />
        <Route path={PickingUpPath.PICKUP_PICKINGUP_MAP} element={<AuthGuard redirectTo="/login"><PickingUpMapModePage /></AuthGuard>} />
        {/* 揽收完成相关路由 */}
        <Route path={PickupFinishedPath.PICKUP_FINISHED} element={<AuthGuard redirectTo="/login"><PickupFinishedPage /></AuthGuard>} />
        <Route path={PickupFinishedPath.PICKUP_FINISHED_DETAIL} element={<AuthGuard redirectTo="/login"><PickupFinishedDetailPage /></AuthGuard>} />
        <Route path="/pickup/to-picked-up" element={<AuthGuard redirectTo="/login"><PickedUpFailedToSecPage /></AuthGuard>} />
        {/*司机计划外扫描领单路由*/}
        <Route path={UserMenuPath.USER_MENU_IDENTIFICATION} element={<AuthGuard redirectTo="/login"><ParcelIdentificationPage /></AuthGuard>} />

        {/*运输app相关路由*/}
        <Route path={TmsPath.TMS_TRANSPORTING} element={<AuthGuard redirectTo="/login"><TransportPage /></AuthGuard>} />
        <Route path={TmsPath.TMS_TRANSPORTING_DETAIL} element={<AuthGuard redirectTo="/login"><TransportDetailPage /></AuthGuard>} />
        <Route path={TmsPath.TMS_TRANSPORTING_ARRIVING} element={<AuthGuard redirectTo="/login"><TransportArrivingPage /></AuthGuard>} />
        <Route path={TmsPath.TMS_TRANSPORTING_DEPARTING} element={<AuthGuard redirectTo="/login"><TransportDepartingPage /></AuthGuard>} />
        <Route path={TmsPath.TMS_TRANSPORT_EXCEPTION} element={<AuthGuard redirectTo="/login"><TransportExceptionPage /></AuthGuard>} />
        <Route path={TmsPath.TMS_TRANSPORT_EXCEPTION_REPORTED} element={<AuthGuard redirectTo="/login"><TransportExceptionReportedPage /></AuthGuard>} />
        <Route path={TmsPath.TMS_TRANSPORT_FINISHED} element={<AuthGuard redirectTo="/login"><TransportFinishedPage /></AuthGuard>} />
        <Route path={TmsPath.TMS_TRANSPORT_FINISHED_DETAIL} element={<AuthGuard redirectTo="/login"><TransportFinishedDetailPage /></AuthGuard>} />
        <Route path={TmsPath.TMS_TRANSPORT_SETTINGS} element={<AuthGuard redirectTo="/login"><TransportSettingsPage /></AuthGuard>} />
        <Route path={TmsPath.TMS_TRANSPORT_SETTINGS_LANGUAGE} element={<AuthGuard redirectTo="/login"><TransportLanguagePage /></AuthGuard>} />
        <Route path={TmsPath.TMS_TRANSPORT_SETTINGS_NAVIGATION_APP} element={<AuthGuard redirectTo="/login"><TransportNavigationAppPage /></AuthGuard>} />

        </Routes>
    </div>
    </ConfigProvider>
  );
};

export default App;
